import React from "react";

export default function MoreInfo() {
  return (
    <div>
      <h1>Meer Info</h1>
    </div>
  );
}
